import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import './plugins/apexcharts';
import router from './router/index';
import store from './store/index';
// offline時の処理用ライブラリ
import VueOffline from 'vue-offline';
import Msal from './plugins/msal';
import axios from 'axios';
import VueAxios from 'vue-axios';
import mixin from '@/utils/mixin';
import VueMoment from 'vue-moment';
import moment from 'moment';
import 'moment/locale/ja';
import 'moment/locale/zh-cn';
import UUID from 'vue-uuid';
import VueI18n from 'vue-i18n';
import cookies from 'vue-cookies';
import dayjs from '@/utils/dayjs';
import 'dayjs/locale/ja';
import 'dayjs/locale/zh-cn';

// vconsole
// import VConsole from 'vconsole/dist/vconsole.min.js'

Vue.config.devtools = true;
Vue.config.productionTip = false;

// ブラウザの言語設定を取得
const language = (
  (window.navigator.languages && window.navigator.languages[0]) ||
  window.navigator.language ||
  window.navigator.userLanguage ||
  window.navigator.browserLanguage
).split('-')[0];
console.log(`ブラウザ言語： ${language}`);

// VueI18nの設定
Vue.use(VueI18n);
export const i18n = new VueI18n({
  locale: language,
  messages: {
    en: require('@/locales/en.json'),
    ja: require('@/locales/ja.json'),
    // zh: require('@/locales/zh.json')
  },
});

moment.locale(language === 'zh' ? 'zh-cn' : language);
Vue.use(VueMoment, { moment });

dayjs.locale(language === 'zh' ? 'zh-cn' : language);
Vue.prototype.$dayjs = dayjs;

Vue.use(VueOffline);

Vue.use(Msal, {
  auth: {
    clientId: '4b4ddc6a-fa68-4002-94e7-3cbd7779f3a8',
    authority: 'https://login.microsoftonline.com/2c62561c-7d39-4f2d-83da-6f8474c384ed/',
    redirectUri: 'https://www2.kobelink.com',
    navigateToLoginRequestUrl: false,
  },
  request: {
    // KNewIoTRestwvaxzqyhbdsi4アプリケーションの権限を使用して、APIリクエストを行うことができる
    scopes: ['6033c6e0-6284-470b-aefa-d8efd44d3a02/user_impersonation'],
  },
});

Vue.use(VueAxios, axios);

Vue.mixin(mixin);
Vue.use(UUID);

Vue.use(cookies);

// モバイルビューの時にvconsoleを表示する
// const regexp = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
// if (window.navigator.userAgent.search(regexp) !== -1) {
//   console.log('モバイル端末')
//   Vue.use(new VConsole())
// } else {
//   console.log('モバイル端末以外')
// }

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
